import { render } from "./LandingTerms.vue?vue&type=template&id=0cfd1e2d"
import script from "./LandingTerms.vue?vue&type=script&lang=js"
export * from "./LandingTerms.vue?vue&type=script&lang=js"

import "./LandingTerms.vue?vue&type=style&index=0&id=0cfd1e2d&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__